import React from "react";
import { rightBorderPlugin } from "./chartPlugins";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Register chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  rightBorderPlugin
);

const AlertBarChart = ({ classifications = [] }) => {
  const data = {
    labels: ["Total", "New", "Assigned", "Closed"],
    datasets: [
      {
        label: "Alert Classifications",
        data: classifications,
        backgroundColor: [
          "rgba(255, 206, 86, 0.7)", // Yellow
          "rgba(54, 162, 235, 0.7)", // Blue
          "rgba(201, 203, 207, 0.7)",
          "rgba(201, 203, 207, 0.7)",
        ],
        borderRadius: 6,
        barThickness: 50,

        // 👉 spacing between bars
        categoryPercentage: 0.7,
        barPercentage: 0.8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    // 👉 padding inside chart area
    layout: {
      padding: {
        top: 20,
        right: 10,
        left: 10,
      },
    },

    plugins: {
      legend: {
        position: "top",
        labels: {
          padding: 20, // space between legend & chart
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        padding: 10,
      },
    },

    scales: {
      x: {
        grid: {
          drawBorder: true,
        },
        border: {
          display: true,
          color: "#ccc",
        },
      },

      y: {
        beginAtZero: true,
        // grace: "10%",
        ticks: {
          stepSize: 5,
        },
        grid: {
          drawBorder: true,
        },
        border: {
          display: true,
          color: "#ccc",
        },
      },
    },
  };

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default AlertBarChart;
